var map = {
	"./HIES.png": "9861",
	"./JATANEGARA.png": "8c58",
	"./bm.png": "5377",
	"./en.png": "70ff",
	"./favicon.png": "99dd",
	"./logo.png": "cf05",
	"./logojabatan.png": "d550"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";